import { usePermissions } from '@refinedev/core';
import { Permissions } from '@shared/constants/permissions';
import { Col, Row, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { DocumentCard } from './components/DocumentCard';

import type { DocumentKind } from './api';

const { Title, Text } = Typography;

/**
 * Раздел «Документы»: публикация PDF-документов платформы.
 *
 * Карточка на каждый тип: публичная оферта (с подтверждением перед загрузкой —
 * пользователи акцептуют новую версию при следующем входе) и справочные
 * документы (сейчас FAQ поддержки). Новый справочный документ на бэке =
 * новая запись в `DOCUMENTS` здесь: механизм общий (`POST /api/admin/documents/{kind}`),
 * меняются только `kind` и тексты. Загрузка гейтится правом `settings.write`.
 */
export function DocumentsPage() {
  const { t } = useTranslation(['documents', 'common']);
  const { data: perms } = usePermissions<string[]>({});
  const canUpload = perms?.includes(Permissions.SETTINGS_WRITE) ?? false;

  const documents: { kind: DocumentKind; confirm: boolean }[] = [
    { kind: 'offer', confirm: true },
    { kind: 'support-faq', confirm: false },
  ];

  return (
    <Space direction="vertical" size={24} style={{ width: '100%' }}>
      <div>
        <Title level={3} style={{ marginBlockEnd: 4, fontWeight: 600 }}>
          {t('documents:title')}
        </Title>
        <Text type="secondary" style={{ fontSize: 14 }}>
          {t('documents:subtitle')}
        </Text>
      </div>

      <Row gutter={[24, 24]}>
        {documents.map(({ kind, confirm }) => (
          <Col key={kind} xs={24} xl={12}>
            <DocumentCard
              kind={kind}
              title={t(`documents:kinds.${kind}.title`)}
              description={t(`documents:kinds.${kind}.description`)}
              confirmText={confirm ? t(`documents:kinds.${kind}.confirm`) : undefined}
              canUpload={canUpload}
            />
          </Col>
        ))}
      </Row>
    </Space>
  );
}
